import { MiddlewareAPI, Dispatch, Action } from 'redux'
import { postRequest, urlBuilder } from 'tfs.front-end-utils/requests'

import staticData from '../../config/staticData'

import addNotification from '../../actions/notifications/addNotification'
import { REQUEST_CHECK_OUT_PASSENGER } from '../../actions/passengers/requestCheckOutPassenger'
import { receiveCheckOutPassenger } from '../../actions/passengers'

import {
  buildServerNotification,
  dispatchErrorNotifications,
  buildGenericNotification,
} from '../../utils/notifications'
import getLabels from '../../utils/getLabels'
import generateAuthorizationHeaders from '../../utils/requests/generateAuthorizationHeaders'
import customTourOperatorParameters from '../../utils/tourOperators/customTourOperatorParameters'

export interface CheckOutPassengersAction extends Action {
  data: {
    passengerId: string
    flightId: string
  }
}

export default ({ dispatch }: MiddlewareAPI) => (next: Dispatch) => async (
  action: CheckOutPassengersAction
) => {
  next(action)

  if (action.type !== REQUEST_CHECK_OUT_PASSENGER) {
    return
  }

  try {
    const {
      endpoints: {
        allotments: { url, headers },
      },
    } = staticData

    const fixedUrl = url.endsWith('/') ? url : `${url}/`
    const requestURL = urlBuilder(
      `${fixedUrl}${action.data.flightId}/checkout`,
      customTourOperatorParameters()
    )
    const passengerData = { passengerIds: [action.data.passengerId] }
    const authHeaders = await generateAuthorizationHeaders(headers)

    const response = await postRequest(requestURL, {
      headers: { ...headers, ...authHeaders },
      body: JSON.stringify(passengerData),
    })

    response.passengersIds.forEach((passengerId: string) => {
      dispatch(receiveCheckOutPassenger(passengerId, action.data.flightId))
    })

    if (response.errors.length) {
      dispatchErrorNotifications(dispatch, [
        ...response.errors,
        buildGenericNotification(getLabels('passenger_checked_out')),
      ])
    }
  } catch (error) {
    dispatch(addNotification(buildServerNotification(error)))
  }
}
